import { WizardStepsComponentProps } from './wizard-steps.model';
import WizardStepsView from './wizard-steps.view';

// Decision making component
// This component will be responsible for deciding which UI to render
// based on the current state of the application
export const WizardStepsController = (props: WizardStepsComponentProps) => {
  return <WizardStepsView {...props} />;
};
